module.exports = __webpack_public_path__ + "img/systemComponents.67e9b0b4.svg";